import { BoxProps } from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import EmptyList from 'components/Shared/EmptyList';
import React, { memo, useCallback } from 'react';
import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';

import Card from '../Component/Card';

interface IProps {
  metrics: {
    score: number;
    max: number;
  }
}

const useStyles = makeStyles(theme => ({
  content: {
    alignSelf: 'center'
  },
  iconStatus: {
    verticalAlign: 'middle'
  },
  scoreText: {
    fill: theme.palette.text.secondary,
    textTransform: 'uppercase',
    fontSize: '.9rem',
  },
  score: {
    fontWeight: 700,
    fontSize: '1.2rem',
  },
}));

const LabelFormatted = (props: any) => {
  const { cx, cy } = props.viewBox;
  const { value } = props;
  const classes = useStyles();

  return (
    <>
      <text x={cx} y={cy - 10} textAnchor="middle">
        <Typography x={cx} component='tspan' variant='h4' dy="0.355em" className={classes.score}>
          {value}
        </Typography>
      </text>
      <text x={cx} y={cy + 20} textAnchor="middle">
        <Typography component='tspan' className={classes.scoreText}>
          pontos
        </Typography>
      </text>
    </>
  );
};

const EmptyMessage = () => {
  const contentProps: BoxProps = {
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  };

  return (
    <Card
      height='100%'
      contentProps={contentProps}
      bgcolor='rgba(226,221,235,0.5)'
      bgContent
    >
      <EmptyList message='Nenhum documento cadastrado.' />
    </Card>
  );
};

const Score = memo<IProps>((props) => {
  const { score, max } = props.metrics;
  const classes = useStyles();
  const data = [
    { name: 'Pontos atingidos', score },
    { name: 'Total de pontos possíveis', score: max - score }
  ];

  const getPercentage = useCallback((score, max) => {
    const percentage = (score / max) * 100;

    if (!Number.isInteger(percentage)) return percentage.toFixed(2) + '%';

    return percentage + '%';
  }, []);

  if (!max) {
    return (<EmptyMessage />);
  }

  return (
    <Card height='100%' contentProps={{ height: '100%' }} bgcolor='rgba(226,221,235,0.5)' bgContent>
      <Grid container justify='center'>
        <Grid item xs={12} style={{ display: 'flex' }}>
          <ResponsiveContainer width="50%" height={120}>
            <PieChart height={120}>
              <Pie
                data={data}
                dataKey='score'
                innerRadius={35}
                outerRadius={50}
                startAngle={90}
                endAngle={-270}
              >
                <Legend verticalAlign="bottom" height={36} />
                <Label
                  position="center"
                  value={getPercentage(score, max)}
                  content={<LabelFormatted />}
                />
                <Cell fill='#2CDAE1' />
                <Cell fill='#E0E2E3' />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <ResponsiveContainer width="50%" height={120}>
            <PieChart height={120}>
              <Pie
                data={data}
                dataKey='score'
                innerRadius={35}
                outerRadius={50}
                startAngle={90}
                endAngle={-270}
              >
                <Legend verticalAlign="bottom" height={36} />
                <Label
                  position="center"
                  value={score}
                  content={<LabelFormatted />}
                />
                <Cell fill='#2CDAE1' />
                <Cell fill='#E0E2E3' />
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </Grid>
        <Grid item xs={10} className={classes.content}>
          <Typography align='center'>
            O empreendimento atingiu <strong>{score}</strong>, dentre os <strong>{max} pontos</strong> possíveis.
          </Typography>
        </Grid>
      </Grid>
    </Card >
  );
});

export default Score;